import Header from "../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box } from "@mui/material"

import BackIcon from "../../components/BackIcon"

// import CustomReadableTableServerSide from "../../components/CustomReadableTableServerSide"
import CustomReadableTable from "./components/CustomReadableTable"
import normalFormatDate from "../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../utils/date/HHMMSSFormatHour"
import dayjs from "dayjs"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const VisorErroresSoho = () => {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Visor de Errores Soho</b>
        </div>

        <Box className={StyledRoot}>
          <CustomReadableTable
            endpoint="/IntegracionSoho/getVisorErroresAll"
            columnsTable={[
              {
                accessorKey: "ciacodigo",
                header: "Ciacodigo",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "ciadescri",
                header: "Descripción",
                size: 250,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgproceso",
                header: "Proceso",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgfecha",
                header: "Fecha",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
                filterFn: (row, columnId, filterValue) => {
                  // Formatea la fecha usando normalFormatDate
                  const formattedDate = normalFormatDate(row.getValue(columnId))

                  // Filtra usando el valor formateado
                  return formattedDate.includes(filterValue)
                },
              },
              {
                accessorKey: "msgfecha",
                header: "Hora",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatHour(value)}</span> // Formatear la fecha
                },
                filterFn: (row, columnId, filterValue) => {
                  // Formatea la fecha usando normalFormatDate
                  const formattedDate = normalFormatHour(row.getValue(columnId))

                  // Filtra usando el valor formateado
                  return formattedDate.includes(filterValue)
                },
              },
              {
                accessorKey: "msgusr",
                header: "Usuario",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgipconsumo",
                header: "IP Consumo",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgtipo",
                header: "Tipo",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgerror",
                header: "Error",
                size: 250,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgreg",
                header: "Registro",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default VisorErroresSoho
